import React, { useCallback, useEffect, useState } from 'react';
import Button from 'components/shared/app/Button';
import Config from 'lib/Config';
import Helmet from 'react-helmet';
import axios from 'axios';
import './style.scss';

const AdCreative = (props) => {
    const [loading, setLoading] = useState(true);
    const [fbAccountId, setFBAccountId] = useState();
    const [fbToken, setFBToken] = useState();
    const [prev, setPrev] = useState(null);
    const [next, setNext] = useState(null);
    const [creatives, setCreatives] = useState([]);

    const { auth } = props;
    const user = auth?.user;
    const account = user?.activeAccount;
    const pageSize = 100;

    const fetchCreatives = useCallback(async (direction) => {
        console.log('fetching creatives - ', fbAccountId, fbToken, direction);
        if (!fbAccountId || !fbToken) {
            return;
        }
        let url;
        if (!direction) {
            url = `https://graph.facebook.com/v14.0/${fbAccountId}/adcreatives?limit=${pageSize}&access_token=${fbToken}&fields=name,asset_feed_spec,image_hash,status,video_id`;
        } else if (direction === 'prev' && prev) {
            url = prev;
        } else if (direction === 'next' && next) {
            url = next;
        } else {
            return;
        }

        setLoading(true);
        try {
            const response = await axios.get(url);
            const cData = response.data.data.map(d => ({
                data: d,
                loadedAssets: false
            }))
            setCreatives(cData);
            setPrev(response.data.paging.previous);
            setNext(response.data.paging.next);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log('fetching creatives error - ', error);
        }
    }, [fbAccountId, fbToken, prev, next, loading, creatives, setPrev, setNext, setLoading]);

    const fetchAdImages = useCallback(async (data) => {
        console.log('fetching Ad Images...');
        if (!fbAccountId || !fbToken) {
            return;
        }
        
        const imageHashes: string[] = [];

        if (data.image_hash) {
            imageHashes.push(`"${data.image_hash}"`);
        }
        if (data.asset_feed_spec && data.asset_feed_spec.images) {
            for (let i = 0; i < data.asset_feed_spec.images.length; i += 1) {
                const hash = data.asset_feed_spec.images[i].hash;
                imageHashes.push(`"${hash}"`);
            }
        }

        if (imageHashes.length > 0) {
            const url = `https://graph.facebook.com/v14.0/${fbAccountId}/adimages?access_token=${fbToken}&hashes=[${imageHashes.join(',')}]&fields=name,width,height,status,url`;
            try {
                const response = await axios.get(url);
                console.log('images data - ', response.data);

                const updated = creatives.map(c => {
                    if (c.data.id === data.id) {
                        return {
                            ...c,
                            loadedAdImages: true,
                            images: response.data.data
                        }
                    } else {
                        return c;
                    }
                });
                setCreatives(updated);
            } catch (error) {
                console.log('fetching images error - ', error);
            }
        }
    }, [fbToken, fbAccountId, creatives]);

    useEffect(async () => {
        if (!account || !account.providers) {
            return;
        }
        const providers = account.providers.filter(p => p.name === 'Facebook');
        if (providers.length === 0) {
            return;
        }

        setFBAccountId(providers[0].accountId);
        setFBToken(providers[0].oauth.token);
    }, [account]);

    useEffect(() => {
        fetchCreatives(null);
    }, [fbAccountId, fbToken]);

    const onNext = async () => {
        await fetchCreatives('next');
    }

    const onPrev = async () => {
        await fetchCreatives('prev');
    }

    const loadAdImages = async (data) => {
        await fetchAdImages(data);
    }

    return (
        <React.Fragment>
            <Helmet><title>{Config.SITE_TITLE_PREFIX} - Ad Creative</title></Helmet>
            <div className='ad-creative'>
                <div className="account-info">
                    AccountId: {fbAccountId}
                </div>
                <div className="account-info">
                    FB Token: {fbToken}
                </div>
                <div className="pagination">
                    <Button round simple bold center color="blue" textPosition="center" onClick={() => onPrev()}>Prev</Button>
                    <Button round simple bold center color="blue" textPosition="center" onClick={() => onNext()}>Next</Button>
                </div>
                <div className="creative-list">
                    {creatives.map(creative => (
                        <div key={creative.data.id} className="creative">
                            <div className="creative-info">
                                <label>Ad Creative</label>
                                <pre>{JSON.stringify(creative.data, null, 2)}</pre>
                            </div>
                            {!creative.loadedAdImages &&
                                <Button round simple bold center color="blue" textPosition="center" onClick={() => loadAdImages(creative.data)}>Load Ad Images</Button>
                            }
                            {creative.loadedAdImages &&
                                <div className="ad-images">
                                    {creative.images.map(image => (
                                        <div key={image.id} className="ad-image">
                                            <label>Ad Image</label>
                                            <div>
                                                <img src={image.url} alt="" />
                                            </div>
                                            <pre>{JSON.stringify(image, null, 2)}</pre>
                                        </div>
                                    ))}
                                </div>
                            }
                        </div>
                    ))}
                </div>
            </div>
        </React.Fragment>
    )
}

export default AdCreative;